import type { ConceptDef } from '../types';

export const beginningSound: ConceptDef = {
  kind: 'tileMatch',
  id: 'beginning-sound',
  label: 'Beginning Sound',
  category: 'Literacy',
  description: 'Hear a starting letter; tap a word that starts with it.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'Which starts with B?', answer: '🎈 ball' },
      { say: 'Which starts with C?', answer: '🐱 cat' },
      { say: 'Which starts with D?', answer: '🐶 dog' },
      { say: 'Which starts with F?', answer: '🐟 fish' },
      { say: 'Which starts with H?', answer: '🏠 house' },
      { say: 'Which starts with S?', answer: '🌞 sun' },
    ],
  },
};
